import { useHistory } from 'react-router';
import { PATHS, twMerge } from '@belong/common';
import { Button } from '@belong/ui';
import { useFeatureFlag } from 'hooks/use-account-redesign';
import { useActiveFullManagementHomes } from 'hooks/useActiveFullManagementHomes';
import { STRINGS } from 'maintenance/strings';
import styles from './book-a-pro-button.module.css';

type BookAProButtonProps = {
  userRole: 'Homeowner' | 'Resident';
  currentLeaseUnitId?: string;
  containerClassName?: string;
};

export const BookAProButton = ({
  userRole = 'Homeowner',
  currentLeaseUnitId,
  containerClassName,
}: BookAProButtonProps) => {
  const history = useHistory();
  const { isEnabled: isMaintenanceAgentEnabled } =
    useFeatureFlag('maintenance-agent');
  const { isEnabled: isRecurringServicesCreateEnabled } = useFeatureFlag(
    'recurrence-pro-services',
  );
  const activeFullManagementHomes = useActiveFullManagementHomes();
  const hasActiveFullManagementHomes = activeFullManagementHomes.length > 0;

  const handleBookAProClick = () => {
    // `| undefined`: neither branch below runs for any other `userRole`, and the
    // push already received `undefined` in that case.
    let bookAProURL: string | undefined;
    if (userRole === 'Homeowner') {
      bookAProURL = isRecurringServicesCreateEnabled
        ? PATHS.HOMEOWNER_CREATE_TASK
        : '/homeowner/pro-services/Repair';
    }
    if (userRole === 'Resident') {
      bookAProURL = isRecurringServicesCreateEnabled
        ? PATHS.RESIDENT_CREATE_TASK
        : isMaintenanceAgentEnabled
          ? `${PATHS.RESIDENT_MAINTENANCE_SCHEDULE.replace(':unitId', currentLeaseUnitId!)}?from=create`
          : PATHS.RESIDENT_PRO_SERVICE_CREATE.replace(':proService', 'Repair');
    }

    return history.push(bookAProURL!);
  };

  return (
    <div
      className={twMerge(
        'fixed inset-x-sm sm:relative sm:inset-x-auto',
        styles.buttonWrapper,
        containerClassName,
      )}
    >
      <Button
        buttonType="primary"
        onClick={handleBookAProClick}
        disabled={
          userRole === 'Homeowner'
            ? !hasActiveFullManagementHomes
            : !currentLeaseUnitId
        }
        className="w-full px-sm"
      >
        {STRINGS['submit-request']}
      </Button>
    </div>
  );
};
